import { NgModule, Optional, SkipSelf } from "@angular/core";
import { CommonModule } from "@angular/common";

import { SharedModule } from "../shared/shared.module";
import { SurveyRoutingModule } from "./survey-routing.module";
import { SurveyFormComponent } from "./survey-form/survey-form.component";
import { SurveyQuestionComponent } from "./survey-form/survey-question/survey-question.component";
import { EnsureModuleLoadedOnceGuard } from "../../../../shared-lib/src/public-api";
import { EducationSurveyComponent } from './education-survey/education-survey.component';
import { MatSelectFilterModule } from 'mat-select-filter';
import { HouseholdIdModal } from './household-id-modal/household-id-modal.component';
import { HouseholdConfirmationdModal } from './household-confirmation-modal/household-confirmation-modal.component';
import { ExistingHouseholdModalComponent } from './existing-household-modal/existing-household-modal.component';
import { SearchResultsModalComponent } from './seach-results-modal/seach-results-modal.component';
import { HouseholdSearchComponent } from './household-search/household-search.component';
import { UserTypeSurveyComponent } from "./user-type-survey/user-type-survey.component";

@NgModule({
  imports: [CommonModule, SharedModule, SurveyRoutingModule, 
    MatSelectFilterModule],
  declarations: [
    SurveyRoutingModule.components,
    SurveyFormComponent,
    SurveyQuestionComponent,
    EducationSurveyComponent,
    HouseholdIdModal,
    HouseholdConfirmationdModal,
    ExistingHouseholdModalComponent,
    SearchResultsModalComponent,
    HouseholdSearchComponent,
    UserTypeSurveyComponent
  ],
  exports: [],
  entryComponents: [HouseholdIdModal, HouseholdConfirmationdModal, ExistingHouseholdModalComponent, SearchResultsModalComponent],
  providers: [],
})
export class SurveyModule extends EnsureModuleLoadedOnceGuard {
  // Ensure that ModalModule is only loaded into AppModule
  // Looks for the module in the parent injector to see if it's already been loaded (only want it loaded once)
  constructor(@Optional() @SkipSelf() parentModule: SurveyModule) {
    super(parentModule);
  }
}
